import cookies from 'js-cookie';
import 'antd/es/modal/style';
import _Modal from 'antd/es/modal';
import axios from 'axios';
import 'antd/es/button/style';
import _Button from 'antd/es/button';
import React, { useState } from 'react';

var region = {
  shenzhen: {
    city: 'shenzhen',
    siteName: '深圳巴士集团',
    orgName: '深巴集团',
    logo: './assets/brandname.png',
    cityName: '深圳',
    spelling: 'ShenZhen',
    center: [114.024664, 22.575534],
    domain: '.dotransit.',
    api: '.dotransit.'
  },
  tengxian: {
    city: 'tengxian',
    siteName: '藤县公交',
    orgName: '藤县公交',
    logo: './assets/tengxian/brandname.png',
    cityName: '藤县',
    spelling: 'TengXian',
    center: [110.918911, 23.378623],
    domain: '.dotransit.',
    api: '.tx.dotransit.'
  },
  panzhou: {
    city: 'panzhou',
    siteName: '盘州公交',
    orgName: '盘州公交',
    logo: './assets/tengxian/brandname.png',
    cityName: '盘州',
    spelling: 'PanZhou',
    center: [104.477954, 25.715584],
    domain: '.dotransit.',
    api: '.pz.dotransit.'
  },
  shangli: {
    city: 'shangli',
    siteName: '上栗公交',
    orgName: '上栗公交',
    logo: './assets/tengxian/brandname.png',
    cityName: '上栗',
    spelling: 'ShangLi',
    center: [113.802112, 27.885042],
    domain: '.dotransit.',
    api: '.sl.dotransit.'
  },
  xianning: {
    city: 'xianning',
    siteName: '咸宁公交',
    orgName: '咸宁公交',
    logo: './assets/tengxian/brandname.png',
    cityName: '咸宁',
    spelling: 'XianNing',
    center: [114.329094, 29.847369],
    domain: '.dotransit.',
    api: '.xn.dotransit.'
  }
};
var _city = process.env.CITY;
var _CITY_ = region[_city];

var brandnameImg = '';
var logoImg = '';

switch (_CITY_ === null || _CITY_ === void 0 ? void 0 : _CITY_.city) {
  case 'shenzhen':
    brandnameImg = require('./assets/shenzhen/brandname.png');
    logoImg = require('./assets/shenzhen/logo.png');
    break;

  case 'panzhou':
    brandnameImg = require('./assets/panzhou/brandname.png');
    logoImg = require('./assets/panzhou/logo.png');
    break;

  case 'xianning':
    brandnameImg = require('./assets/xianning/brandname.png');
    logoImg = require('./assets/xianning/logo.png');
    break;

  default:
    brandnameImg = require('./assets/common/brandname.png');
    logoImg = require('./assets/common/logo.png');
}

var imgConfig = {
  brandnameImg: brandnameImg,
  logoImg: logoImg
};

var config = {
  domain: 'net',
  buildTo: process.env.BUILD_TO || 'dev',
  name: ''
};
config.domain = config.buildTo === 'prod' ? 'com' : 'net';
config.name = window.location.host.split('dotransit')[0].split('.')[1];

var getPassortUrl = function getPassortUrl() {
  var webName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'passport';

  var _domain = (_CITY_ === null || _CITY_ === void 0 ? void 0 : _CITY_.domain) + config.domain;

  var url = window.location.protocol + '//' + webName + (config.name ? '.' + config.name : '') + _domain;
  return url;
};

var getApiUrl = function getApiUrl(site) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.buildTo;
  var _apiName = '';

  switch (env) {
    case 'qa':
      _apiName = '.qa';
      break;

    case 'dev-maas':
      _apiName = '.dev-maas';
      break;

    case 'qa-maas':
      _apiName = '.qa-maas';
      break;

    case 'sw':
      _apiName = '.sw';
      break;
  }

  var _domain = window.location.protocol + '//api.' + site + _apiName + (_CITY_ === null || _CITY_ === void 0 ? void 0 : _CITY_.api) + config.domain;

  return _domain;
};

var toLoginPage = function toLoginPage(goto) {
  var _domain = config.name + (_CITY_ === null || _CITY_ === void 0 ? void 0 : _CITY_.domain) + config.domain;

  cookies.remove('token', {
    domain: _domain
  });
  cookies.remove('userinfo', {
    domain: _domain
  });
  cookies.remove('tokenId', {
    domain: _domain
  });
  window.location.href = getPassortUrl() + '?goto=' + (goto || window.location.href);
};

var getWsApiUrl = function getWsApiUrl(site) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.buildTo;
  var _apiName = '';

  switch (env) {
    case 'qa':
      _apiName = '.qa';
      break;

    case 'dev-maas':
      _apiName = '.dev-maas';
      break;

    case 'qa-maas':
      _apiName = '.qa-maas';
      break;

    case 'sw':
      _apiName = '.sw';
      break;
  }

  var _domain = 'ws://' + site + _apiName + (_CITY_ === null || _CITY_ === void 0 ? void 0 : _CITY_.api) + config.domain;

  return _domain;
};

var envConfig = {
  getPassortUrl: getPassortUrl,
  getApiUrl: getApiUrl,
  toLoginPage: toLoginPage,
  getWsApiUrl: getWsApiUrl
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var ZHUYUNAPI = {
  getUserInfoFromCode: '/userpolicy/open/bam/v1/login',
  getZhuyunConfig: '/userpolicy/open/bam/v1/config',
  userInfo: '/userpolicy/userpolicy/auth/v1/check_token',
  loginout: '/userpolicy/userpolicy/auth/v1/log_out'
};

var ZhuyunLogin = /*#__PURE__*/function () {
  function ZhuyunLogin() {
    _classCallCheck(this, ZhuyunLogin);

    this.timer = null;
    this._token = cookies.get('token');
    this.apiBaseURL = this.getApiUrl('dispatch');
    this.szbusApiUrl = null;
    this.szbusZhuyunInfo = {};
    this.isFirst = true;
    this._config = {
      domain: process.env.BUILD_TO === 'prod' ? 'com' : 'net'
    };

    this.removeCodeParameter = function (url) {
      return url.replace(/(\?|&)code=[^&]*(&)?/g, function (p0, p1, p2) {
        return p1 === '?' || p2 ? p1 : '';
      });
    };

    this.removeStateParameter = function (url) {
      return url.replace(/(\?|&)state=[^&]*(&)?/g, function (p0, p1, p2) {
        return p1 === '?' || p2 ? p1 : '';
      });
    };
  }

  _createClass(ZhuyunLogin, [{
    key: "getAuthCode",
    value: // curSystemCode =
    function getAuthCode(url) {
      var re = /(code=\w*)/g;

      var _code = url.match(re);

      if (_code && _code[0]) {
        _code = _code[0].split('=')[1];
        return _code;
      }

      return false;
    }
  }, {
    key: "getApiUrl",
    value: function getApiUrl(domain) {
      var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.env.BUILD_TO;
      return envConfig.getApiUrl(domain, env);
    } // 通过token获取用户信息

  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      return axios.post(this.apiBaseURL + ZHUYUNAPI.userInfo, {
        token: this._token
      });
    }
  }, {
    key: "loginSuccess",
    value: // 登录成功
    function loginSuccess(userinfo) {
      var _name = window.location.host.split('dotransit')[0].split('.')[1];
      axios.defaults.headers['token'] = userinfo.token;

      var _domain = _name + _CITY_.domain + this._config.domain;

      cookies.set('token', userinfo.token, {
        domain: _domain
      });
      cookies.set('userinfo', JSON.stringify(userinfo), {
        domain: _domain
      });
      cookies.set('tokenId', userinfo.tokenId, {
        domain: _domain
      });
      cookies.set('domain', process.env.BUILD_TO === 'prod' ? _domain.slice(1) : _domain, {
        domain: _domain
      });
    } // 退出登录，清除cookie

  }, {
    key: "clearLoginInfo",
    value: function clearLoginInfo() {
      var _name = window.location.host.split('dotransit')[0].split('.')[1];

      var _domain = _name + _CITY_.domain + this._config.domain;

      cookies.remove('token', {
        domain: _domain
      });
      cookies.remove('userinfo', {
        domain: _domain
      });
      cookies.remove('tokenId', {
        domain: _domain
      });
    } // 通过竹云code获取用户信息

  }, {
    key: "getUserInfoFromCode",
    value: function getUserInfoFromCode(authCode) {
      var _this = this;

      return axios.post(this.apiBaseURL + ZHUYUNAPI.getUserInfoFromCode, {
        authCode: authCode,
        systemCode: process.env.SYSTEMCODE
      }).then(function (res) {
        if (res.data.code) {
          if (_this.timer) return;
          _this.timer = setTimeout(function () {
            _Modal.info({
              // title: '登录过期了！',
              content: res.data && res.data.msg || '统一用户登录失败，请联系管理员！',
              okText: '关闭',
              onOk: function onOk() {
                window.location.href = _this.szbusZhuyunInfo && _this.szbusZhuyunInfo.bamIndexUrl;
              }
            });
          }, 0);
          return Promise.resolve(null);
        }

        return Promise.resolve(res.data.data);
      });
    } // 判断页面来源

  }, {
    key: "getPageFrom",
    value: function () {
      var _getPageFrom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var current_url, code, userInfo, newUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                current_url = window.location.href; // 判断是否是竹云登录后跳转过来

                _context2.prev = 1;

                if (!(current_url.includes('code=') && current_url.includes('state='))) {
                  _context2.next = 17;
                  break;
                }

                code = this.getAuthCode(current_url);
                _context2.next = 6;
                return this.getUserInfoFromCode(code);

              case 6:
                userInfo = _context2.sent;

                if (!userInfo) {
                  _context2.next = 16;
                  break;
                }

                this.loginSuccess(userInfo);
                axios.defaults.headers.token = userInfo.token;
                newUrl = this.removeCodeParameter(current_url);
                newUrl = this.removeStateParameter(newUrl);
                window.location.href = newUrl;
                return _context2.abrupt("return", Promise.resolve(userInfo.token));

              case 16:
                return _context2.abrupt("return", Promise.reject('用户授权失败'));

              case 17:
                if (!this._token) {
                  _context2.next = 21;
                  break;
                }

                axios.defaults.headers.token = this._token;
                this.getUserInfo().then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                    var userInfo;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(res.data.code !== 0)) {
                              _context.next = 3;
                              break;
                            }

                            _context.next = 3;
                            return _this2.gotoLoginPage();

                          case 3:
                            userInfo = res.data.data; // console.log('----有token----', userInfo)

                            return _context.abrupt("return", Promise.resolve(userInfo));

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                return _context2.abrupt("return");

              case 21:
                _context2.next = 23;
                return this.gotoLoginPage();

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2["catch"](1);
                console.log('----出错了-----', _context2.t0);

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 25]]);
      }));

      function getPageFrom() {
        return _getPageFrom.apply(this, arguments);
      }

      return getPageFrom;
    }() // 判断在竹云是否有配置

  }, {
    key: "judgeZhuyunConfig",
    value: function () {
      var _judgeZhuyunConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var configInfo;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                configInfo = localStorage.getItem('zhuyunSys') && JSON.parse(localStorage.getItem('zhuyunSys') || '');

                if (!(!this.isFirst && configInfo && configInfo !== '')) {
                  _context3.next = 6;
                  break;
                }

                this.isFirst = false;
                this.szbusZhuyunInfo = configInfo;
                this.szbusApiUrl = configInfo.authUrl;
                return _context3.abrupt("return", Promise.resolve(true));

              case 6:
                return _context3.abrupt("return", axios.post(this.apiBaseURL + ZHUYUNAPI.getZhuyunConfig, {
                  systemCode: process.env.SYSTEMCODE
                }).then(function (res) {
                  if (res.data.code !== 0) {
                    _this3.szbusApiUrl = null;
                    _this3.szbusZhuyunInfo = {};
                    localStorage.removeItem('zhuyunSys');
                    return Promise.resolve(false);
                  }

                  var sysInfo = res.data.data || [];

                  if (sysInfo.length) {
                    _this3.szbusApiUrl = sysInfo[0].authUrl;
                    _this3.szbusZhuyunInfo = sysInfo[0];
                    localStorage.setItem('zhuyunSys', JSON.stringify(sysInfo[0]));
                    return Promise.resolve(true);
                  } else {
                    _this3.szbusApiUrl = null;
                    _this3.szbusZhuyunInfo = {};
                    localStorage.removeItem('zhuyunSys');
                    return Promise.resolve(false);
                  }
                }));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function judgeZhuyunConfig() {
        return _judgeZhuyunConfig.apply(this, arguments);
      }

      return judgeZhuyunConfig;
    }()
  }, {
    key: "gotoLoginPage",
    value: function () {
      var _gotoLoginPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var current_url, REDIRECT_URL;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                current_url = window.location.href; // 从子系统跳转到登录系统的，不做跳竹云处理

                if (!(process.env.SYSTEMCODE === 'passport' && current_url.indexOf('goto=') > -1)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                if (!(this.szbusApiUrl && _CITY_.city === 'shenzhen')) {
                  _context4.next = 7;
                  break;
                }

                REDIRECT_URL = "".concat(this.szbusApiUrl, "/idp/oauth2/authorize?state=xxxx&client_id=").concat(this.szbusZhuyunInfo.clientId, "&response_type=code&redirect_uri=").concat(current_url); // console.log('------是否跳竹云------', REDIRECT_URL)

                window.location.href = REDIRECT_URL;
                return _context4.abrupt("return");

              case 7:
                this.authInfoOutOfTime();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function gotoLoginPage() {
        return _gotoLoginPage.apply(this, arguments);
      }

      return gotoLoginPage;
    }() // 登录过时弹窗

  }, {
    key: "authInfoOutOfTime",
    value: function authInfoOutOfTime() {
      var _this4 = this;

      // 登录系统不弹窗
      if (process.env.SYSTEMCODE === 'passport') {
        return;
      }

      if (this.timer) return;
      this.timer = setTimeout(function () {
        _Modal.info({
          title: '登录过期了！',
          content: '当前用户登录已经过期，请前往重新登录！',
          okText: '关闭',
          onOk: function onOk() {
            _this4.toPassportPage();
          }
        });
      }, 10);
    } // 跳转到passport页面

  }, {
    key: "toPassportPage",
    value: function toPassportPage() {
      localStorage.removeItem('zhuyunSys');
      envConfig.toLoginPage();
    } // 退出登录

  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var isConfigZhuyun;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.judgeZhuyunConfig();

              case 2:
                isConfigZhuyun = _context5.sent;

                if (!(isConfigZhuyun && _CITY_.city === 'shenzhen')) {
                  _context5.next = 14;
                  break;
                }

                localStorage.removeItem('zhuyunSys'); // 防止出现无token的情况

                if (cookies.get('token')) {
                  this.serviceLogout();
                }

                this.clearLoginInfo(); // 竹云配置，跳转到竹云系统主页

                if (!this.szbusZhuyunInfo.bamIndexUrl) {
                  _context5.next = 10;
                  break;
                }

                window.location.href = this.szbusZhuyunInfo.bamIndexUrl;
                return _context5.abrupt("return");

              case 10:
                if (!(process.env.SYSTEMCODE === 'passport')) {
                  _context5.next = 13;
                  break;
                }

                window.location.reload();
                return _context5.abrupt("return");

              case 13:
                return _context5.abrupt("return");

              case 14:
                this.passportloginout();

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "serviceLogout",
    value: function serviceLogout() {
      return axios.post(this.apiBaseURL + ZHUYUNAPI.loginout, {});
    }
  }, {
    key: "passportloginout",
    value: function () {
      var _passportloginout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.serviceLogout();

              case 2:
                this.toPassportPage();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function passportloginout() {
        return _passportloginout.apply(this, arguments);
      }

      return passportloginout;
    }()
  }]);

  return ZhuyunLogin;
}();

var zhuyunLogin = new ZhuyunLogin();

function Counter() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var increment = function increment() {
    return setCount(function (count) {
      return count + 1;
    });
  };

  var decrement = function decrement() {
    return setCount(function (count) {
      return count - 1;
    });
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: decrement
  }, "-"), /*#__PURE__*/React.createElement("p", null, count), /*#__PURE__*/React.createElement(_Button, {
    onClick: increment
  }, "+"));
}

var brandnameImg$1 = imgConfig.brandnameImg;
var logoImg$1 = imgConfig.logoImg;

export { Counter as Foo, zhuyunLogin as ZhuyunLogin, _CITY_, brandnameImg$1 as brandnameImg, envConfig, logoImg$1 as logoImg };



//////////////////
// WEBPACK FOOTER
// ./node_modules/udian-tob-lib/dist/index.esm.js
// module id = 190
// module chunks = 0